var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoadingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.20799 13.4917C2.37363 13.8603 2.2091 14.2933 1.8405 14.459C1.4719 14.6246 1.03881 14.4601 0.873162 14.0915C0.300253 12.8166 0 11.4285 0 10C0 4.47726 4.47726 0 10 0C15.5227 0 20 4.47726 20 10C20 15.5227 15.5227 20 10 20C7.65339 20 5.42972 19.1881 3.65267 17.7281C3.34042 17.4715 3.29526 17.0105 3.55179 16.6982C3.80833 16.386 4.26941 16.3408 4.58166 16.5973C6.09934 17.8442 7.9955 18.5366 10 18.5366C14.7145 18.5366 18.5366 14.7145 18.5366 10C18.5366 5.28549 14.7145 1.46341 10 1.46341C5.28549 1.46341 1.46341 5.28549 1.46341 10C1.46341 11.2208 1.71947 12.4046 2.20799 13.4917Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingIcon);
export default __webpack_public_path__ + "static/media/loading-icon.316a191b17ccf6d7c199f9d20a184339.svg";
export { ForwardRef as ReactComponent };